import React from 'react';
import { VideoParagraph } from '../../Blog/Paragraphs/VideoParagraph';

const TechVideos = () => {
    const videos = [
        {
            text: "Как оценить доступность сервиса, то есть что все услуги на сайте доступны?",
            src: "https://www.youtube.com/embed/c18qS4f0eLY"
        },
        {
            text: "Как быстро анализировать IT-инфраструктуру сайта или приложения?",
            src: "https://www.youtube.com/embed/7HPNZgh-VGQ"
        },
        {
            text: "Как моментально найти ошибку в коде?",
            src: "https://www.youtube.com/embed/6DBPSGS3KNk"
        },
        {
            text: "Как анализировать цифровое поведение пользователей?",
            src: "https://www.youtube.com/embed/157cRXTOdxE"
        },
        {
            text: "Как контролировать бизнес-операции?",
            src: "https://www.youtube.com/embed/gfNsJ3bV4as"
        },
        {
            text: "Как оценить эффективность маркетинговой кампании?",
            src: "https://www.youtube.com/embed/huE8A1XDuOU"
        },
        {
            text: "Как построить воронку продаж?",
            src: "https://www.youtube.com/embed/zpPZQd5OgCo"
        }
    ];

    return (
        <div className="tech-videos">
            <h2 className="text-2xl font-bold mb-4">Технологии</h2>
            <div className="mb-4 text-gray-600">
                Делимся прикладными инструкциями, которые показывают как использовать функционал платформы.
            </div>
            
            <div className="space-y-6">
                {videos.map((video, index) => (
                    <div key={index} className="mb-6">
                        <VideoParagraph 
                            width="100%"
                            text={video.text} 
                            src={video.src} 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TechVideos;